import { render, staticRenderFns } from "./zhankuOverThreshold.vue?vue&type=template&id=37317bdb"
import script from "./zhankuOverThreshold.vue?vue&type=script&lang=js"
export * from "./zhankuOverThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports